import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Heading = ({ title, button, search, onSearch }, context) => (
  <div id="head">
    <div id="title">{title}</div>
    <div id="subnav">
      {button ? button : null}
      <div id="search">
        <span id="adv">
          <Link to="/search">Adv</Link>
        </span>
        <div>
          <input
            id="q"
            type="text"
            defaultValue={search}
            placeholder="Search studies"
            onKeyUp={e =>
              e.keyCode === 13
                ? onSearch
                    ? onSearch(e.target.value)
                    : context.router.history.push(
                        `/types?search=${e.target.value}`
                      )
                : null}
          />
        </div>
      </div>
    </div>
  </div>
);

Heading.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default Heading;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/heading.js